import Box from "@material-ui/core/Box"
import React from "react"

const AdminFullSizeCell = props => {
    return (
        <Box component="tr" height={400} position="relative">
            <td {...props} colSpan={999} />
        </Box>
    )
}

export default AdminFullSizeCell
